export default "__VITE_ASSET__e7737749__"